export default __webpack_public_path__ + "static/media/pci-logo.eb3b1991.png";